import { render } from "./ButtonSurvey.vue?vue&type=template&id=0e90abcb&scoped=true"
import script from "./ButtonSurvey.vue?vue&type=script&lang=js"
export * from "./ButtonSurvey.vue?vue&type=script&lang=js"

import "./ButtonSurvey.vue?vue&type=style&index=0&id=0e90abcb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e90abcb"]])

export default __exports__